//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Modified_Prognostic_Scoring_System_for_Trophoblastic_Tumor',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '＜40'},
        {value: '1', name: '≥40'}
      ],
      dataList2: [
        {value: '0', name: '葡萄胎'},
        {value: '1', name: '流产'},
        {value: '2', name: '足月产'}
      ],
      dataList3: [
        {value: '0', name: '＜4'},
        {value: '1', name: '4~＜7'},
        {value: '2', name: '7~＜13'},
        {value: '4', name: '≥13'}
      ],
      dataList4: [
        {value: '0', name: '＜10^3'},
        {value: '1', name: '10^3~＜10^4'},
        {value: '2', name: '10^4~＜10^5'},
        {value: '4', name: '≥10^5'}
      ],
      dataList5: [
        {value: '1', name: '3~＜5cm'},
        {value: '2', name: '≥5cm'}
      ],
      dataList6: [
        {value: '0', name: '肺'},
        {value: '1', name: '脾、肾'},
        {value: '2', name: '肠道'},
        {value: '4', name: '肝、脑'}
      ],
      dataList7: [
        {value: '1', name: '1~4'},
        {value: '2', name: '5~8'},
        {value: '4', name: '＞8'}
      ],
      dataList8: [
        {value: '2', name: '单药'},
        {value: '4', name: '两种或两种以上联合化疗'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = false
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (form[key]) {
            flag = true
            result += Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Modified_Prognostic_Scoring_System_for_Trophoblastic_Tumor.vue